import { render, staticRenderFns } from "./otpInput.vue?vue&type=template&id=09affa6c&"
import script from "./otpInput.vue?vue&type=script&lang=js&"
export * from "./otpInput.vue?vue&type=script&lang=js&"
import style0 from "./otpInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports